import React from 'react'
import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'
import {MemberPlusTimeline} from './MemberPlusTimeline'
import {NonMemberPlusTimeline} from './NonMemberPlusTimeline'
import {
  ConfettiContainer,
  ConfettiContent,
  ConfettiImage,
  MainContainer,
  PlusText,
  TravelWithHeading
} from './styles'
import ContentWrapper from '../../../../designSystem/helpers/ContentWrapper'
import Heading from '../../../../designSystem/Heading'
import Text from '../../../../designSystem/Text'
import {PlusBirdIllustration} from '../../../../../foundation/icons/PlusBirdIllustration'

interface PropsType {
  isMemberPlus: boolean
  isOverlay: boolean
}

export const TravelWithPlus = ({isMemberPlus, isOverlay}: PropsType) => {
  const Timeline = isMemberPlus ? MemberPlusTimeline : NonMemberPlusTimeline

  return (
    <MainContainer isOverlay={isOverlay}>
      <ContentWrapper paddingSize="s000" paddingBottomSize="s300">
        <PlusBirdIllustration width="160px" />
      </ContentWrapper>
      <ConfettiContainer>
        <ConfettiImage />
        <ConfettiContent>
          <TravelWithHeading
            appearance="title1"
            align="center"
            as="h2"
            marginBottomSize="s300"
          >
            <FormattedMessageWrapper
              id="findHotel"
              defaultMessage="FindHotel {plus}"
              values={{
                plus: (
                  <PlusText>
                    <FormattedMessageWrapper
                      id="membership.plus"
                      defaultMessage="Plus"
                    />
                  </PlusText>
                )
              }}
            />
          </TravelWithHeading>
          <Heading
            align="center"
            appearance="title2"
            marginTopSize="s100"
            as="h3"
          >
            <FormattedMessageWrapper
              id="membership.sameStayEvenBetterPrice"
              defaultMessage="Same stay, even better price."
            />
          </Heading>
        </ConfettiContent>
      </ConfettiContainer>

      <Text marginTopSize="s300">
        <FormattedMessageWrapper
          id="membership.findhotelPlusDescription"
          defaultMessage="As a FindHotel Plus Member, you have access to the best accommodation deals available anywhere. It’s our way of saying thanks – because we know how great it feels to know you’ve found the perfect room at the best price."
        />
      </Text>

      <Heading
        appearance="title1"
        align="center"
        marginTopSize="s900"
        marginBottomSize="s000"
        as="h3"
      >
        <FormattedMessageWrapper
          id="membership.HowItWorks"
          defaultMessage="How it works"
        />
      </Heading>
      <Timeline />
    </MainContainer>
  )
}
